var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundmenusvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.577 22.578C45.7849 27.3477 44.4385 32.056 41.7402 35.9946C39.042 39.9333 35.1378 42.8893 30.6149 44.418C26.092 45.9468 21.195 45.9657 16.6605 44.4718C12.126 42.9779 8.1992 40.052 5.4707 36.1342",
    stroke: "#6AA2B2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50492 24.078C1.47203 22.506 1.604 20.9349 1.89867 19.3905C2.71273 15.1445 4.7575 11.2318 7.77849 8.13917C10.7995 5.04656 14.6633 2.9107 18.889 1.99741C23.1147 1.08413 27.5156 1.43375 31.5441 3.00278C35.5726 4.5718 39.0507 7.29092 41.5455 10.8217",
    stroke: "#6AA2B2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6362 9.88422L41.8081 11.0748L42.8206 1.5311",
    stroke: "#6AA2B2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 36.8186L5.02041 35.628L3.99854 45.1717",
    stroke: "#6AA2B2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1361 17.3561C29.6145 16.1419 28.7428 15.1108 27.6323 14.3944C26.5218 13.678 25.223 13.3089 23.9018 13.3342C18.2768 13.3342 18.0799 17.3561 18.0799 17.3561C18.0799 17.3561 17.2361 22.3061 24.108 22.8405C31.2424 23.3842 30.1361 28.3155 30.1361 28.3155C30.1361 28.3155 29.4049 32.6092 24.108 32.8811C18.8111 33.153 17.1611 27.5842 17.1611 27.5842",
    stroke: "#6AA2B2",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8828 9.77173V36.9967",
    stroke: "#6AA2B2",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundmenusvg);
export default __webpack_public_path__ + "static/media/refundmenusvg.366d31c3917a08907d64a9fbf51eaf8d.svg";
export { ForwardRef as ReactComponent };